import './FindPassword.scss';
import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaArrowLeft, FaCheck } from 'react-icons/fa';
import fnc from '../mymod/commFunction';

const VERIFY_SECONDS = 5 * 60;

function FindPassword() {
const navigate = useNavigate();
const [userId, setUserId] = useState('');
const [hp, setHp] = useState('');
const [verifyCode, setVerifyCode] = useState('');
const [newPw, setNewPw] = useState('');
const [confirmPw, setConfirmPw] = useState('');
const [codeSent, setCodeSent] = useState(false);
const [resetDone, setResetDone] = useState(false);
const [timeLeft, setTimeLeft] = useState(0);
const [redirectCount, setRedirectCount] = useState(3);
const timerRef = useRef(null);
const redirectRef = useRef(null);

useEffect(() => () => {
    clearInterval(timerRef.current);
    clearInterval(redirectRef.current);
}, []);

useEffect(() => {
    if (!resetDone) return;
    setRedirectCount(3);
    redirectRef.current = setInterval(() => {
    setRedirectCount((prev) => {
        if (prev <= 1) {
        clearInterval(redirectRef.current);
        navigate('/login');
        return 0;
        }
        return prev - 1;
    });
    }, 1000);
    return () => clearInterval(redirectRef.current);
}, [resetDone, navigate]);

function startTimer() {
    clearInterval(timerRef.current);
    setTimeLeft(VERIFY_SECONDS);
    timerRef.current = setInterval(() => {
    setTimeLeft((prev) => {
        if (prev <= 1) { clearInterval(timerRef.current); return 0; }
        return prev - 1;
    });
    }, 1000);
}

function formatTime(sec) {
    const m = String(Math.floor(sec / 60)).padStart(2, '0');
    const s = String(sec % 60).padStart(2, '0');
    return `${m}:${s}`;
}

const step = resetDone ? 3 : codeSent ? 2 : 1;

function handleSendCode(e) {
    e.preventDefault();
    if (!userId.trim()) { alert('아이디를 입력해주세요.'); return; }
    if (!hp.trim()) { alert('휴대폰 번호를 입력해주세요.'); return; }
    fnc.sendAxios('/findIdRoutes/sendResetCode', { id: userId.trim(), hp: hp.trim() }, (res) => {
    if (res.error) { alert(res.message || '인증번호 전송에 실패했습니다.'); return; }
    setCodeSent(true);
    setVerifyCode('');
    setNewPw('');
    setConfirmPw('');
    startTimer();
    });
}

function handleSubmitReset(e) {
    e.preventDefault();
    if (!verifyCode.trim()) { alert('인증번호를 입력해주세요.'); return; }
    if (timeLeft === 0) { alert('인증번호가 만료되었습니다. 다시 요청해주세요.'); return; }
    if (!newPw) { alert('새 비밀번호를 입력해주세요.'); return; }
    if (newPw.length < 6) { alert('비밀번호는 6자 이상이어야 합니다.'); return; }
    if (newPw !== confirmPw) { alert('비밀번호가 일치하지 않습니다.'); return; }

    fnc.sendAxios('/findIdRoutes/resetPassword', {
    id: userId.trim(),
    hp: hp.trim(),
    code: verifyCode.trim(),
    newPw,
    }, (res) => {
    if (res.error) { alert(res.message || '비밀번호 변경에 실패했습니다.'); return; }
    clearInterval(timerRef.current);
    setResetDone(true);
    });
}

function handleRetry() {
    clearInterval(timerRef.current);
    setUserId(''); setHp(''); setVerifyCode(''); setNewPw(''); setConfirmPw('');
    setCodeSent(false); setResetDone(false); setTimeLeft(0);
}

return (
    <div className='FindPassword'>
    <div className='fp-card'>
        <div className='card-header'>
        <h2 className='card-title'>비밀번호 찾기</h2>
        <button type='button' className='btn-back' onClick={() => navigate('/login')}>
            <FaArrowLeft /> 로그인
        </button>
        </div>

        {/* 단계 표시 */}
        <div className='step-indicator'>
        <div className={`step-dot ${step >= 1 ? 'done' : ''} ${step === 1 ? 'active' : ''}`}>
            <span>1</span><em>정보 입력</em>
        </div>
        <div className={`step-line ${step >= 2 ? 'done' : ''}`} />
        <div className={`step-dot ${step >= 2 ? 'done' : ''} ${step === 2 ? 'active' : ''}`}>
            <span>2</span><em>인증+변경</em>
        </div>
        <div className={`step-line ${step >= 3 ? 'done' : ''}`} />
        <div className={`step-dot ${step >= 3 ? 'done' : ''}`}>
            <span>{step === 3 ? <FaCheck /> : '3'}</span><em>완료</em>
        </div>
        </div>

        {/* STEP 1 - 아이디 + 번호 입력 */}
        {step < 3 && (
        <form onSubmit={handleSendCode}>
            <div className='step-block'>
            <label className='field-label' htmlFor='fp-id'>*아이디</label>
            <div className='field-row'>
                <input
                id='fp-id'
                name='userId'
                type='text'
                autoComplete='username'
                className='field-input'
                value={userId}
                onChange={(e) => setUserId(e.target.value)}
                placeholder='가입한 아이디'
                disabled={codeSent && timeLeft > 0}
                />
            </div>
            </div>

            <div className='step-block'>
            <label className='field-label' htmlFor='fp-hp'>*휴대폰 번호</label>
            <div className='field-row'>
                <input
                id='fp-hp'
                name='hp'
                type='tel'
                autoComplete='tel'
                className='field-input'
                value={hp}
                onChange={(e) => setHp(e.target.value)}
                placeholder='01012345678'
                maxLength={11}
                disabled={codeSent && timeLeft > 0}
                />
                <button
                type='submit'
                className={`btn-send ${codeSent && timeLeft > 0 ? 'sent' : ''}`}
                disabled={codeSent && timeLeft > 0}
                >
                {codeSent ? '재전송' : '인증번호 전송'}
                </button>
            </div>
            {codeSent && timeLeft > 0 && (
                <p className='sent-notice'>인증번호가 발송되었습니다.</p>
            )}
            </div>
        </form>
        )}

        {/* STEP 2 - 인증번호 + 새 비밀번호 */}
        {codeSent && step < 3 && (
        <form onSubmit={handleSubmitReset}>
            <div className='step-block'>
            <label className='field-label' htmlFor='fp-code'>*인증번호</label>
            <div className='field-row'>
                <div className='code-wrap'>
                <input
                    id='fp-code'
                    name='verifyCode'
                    type='text'
                    autoComplete='one-time-code'
                    className='field-input code-input'
                    value={verifyCode}
                    onChange={(e) => setVerifyCode(e.target.value)}
                    placeholder='6자리 입력'
                    maxLength={6}
                />
                <span className={`timer-badge ${timeLeft <= 60 ? 'urgent' : ''}`}>
                    {timeLeft > 0 ? formatTime(timeLeft) : '만료'}
                </span>
                </div>
            </div>
            </div>

            <div className='step-block'>
            <label className='field-label' htmlFor='fp-newpw'>*새 비밀번호</label>
            <div className='field-row'>
                <input
                id='fp-newpw'
                name='newPw'
                type='password'
                autoComplete='new-password'
                className='field-input'
                value={newPw}
                onChange={(e) => setNewPw(e.target.value)}
                placeholder='새 비밀번호 (6자 이상)'
                />
            </div>
            </div>

            <div className='step-block'>
            <label className='field-label' htmlFor='fp-confirmpw'>*비밀번호 확인</label>
            <div className='field-row'>
                <input
                id='fp-confirmpw'
                name='confirmPw'
                type='password'
                autoComplete='new-password'
                className='field-input'
                value={confirmPw}
                onChange={(e) => setConfirmPw(e.target.value)}
                placeholder='비밀번호 재입력'
                />
            </div>
            </div>

            <button type='submit' className='btn-submit'>비밀번호 변경</button>
        </form>
        )}

        {/* STEP 3 - 완료 */}
        {step === 3 && (
        <div className='result-panel'>
            <div className='result-icon'><FaCheck /></div>
            <p className='result-label'>비밀번호가 변경되었습니다</p>
            <p className='redirect-notice'>{redirectCount}초 후 로그인 페이지로 이동합니다...</p>
            <button type='button' className='btn-to-login' onClick={() => { clearInterval(redirectRef.current); navigate('/login'); }}>
            로그인으로 이동
            </button>
        </div>
        )}

        {step === 1 && (
        <p className='sub-link'>
            <button type='button' onClick={() => navigate('/find-id')}>아이디도 잊으셨나요?</button>
        </p>
        )}
    </div>
    </div>
);
}

export default FindPassword;
